import { createI18n } from "vue-i18n";
import { defaultLanguage } from "~/core/constants/languages";

const localeModules = import.meta.glob<{
  default: Record<string, unknown>;
}>("~/assets/locales/*/index.ts");

export const i18n = createI18n({
  legacy: false,
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  globalInjection: true,
  messages: {},
});

export async function loadLocale(locale: string) {
  const modulePath = `/src/assets/locales/${locale}/index.ts`;

  const loader = localeModules[modulePath];

  if (!loader) {
    throw new Error(`Locale '${locale}' not found`);
  }

  const messages = await loader();

  i18n.global.setLocaleMessage(locale, messages.default);
}

export async function setLocaleTag(localeTag: string) {
  if (!i18n.global.availableLocales.includes(localeTag)) {
    await loadLocale(localeTag);
  }

  i18n.global.locale.value = localeTag;

  document.documentElement.setAttribute("lang", localeTag);
}
